"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PUBLIC_USER_GUIDE_ENTRY_PATH = exports.PUBLIC_LEGAL_FOOTER_DOCUMENT_PDF_PATHS = exports.DEFAULT_PUBLIC_LEGAL_FOOTER_DOCUMENTS_PREFIX = void 0;
exports.buildPublicLegalFooterDocumentPdfPaths = buildPublicLegalFooterDocumentPdfPaths;
exports.DEFAULT_PUBLIC_LEGAL_FOOTER_DOCUMENTS_PREFIX = "/footer";
function buildPublicLegalFooterDocumentPdfPaths(prefix) {
    const p = prefix.trim().replace(/\/$/, "") || exports.DEFAULT_PUBLIC_LEGAL_FOOTER_DOCUMENTS_PREFIX;
    return {
        legalMentions: `${p}/mentions_legales.pdf`,
        confidentiality: `${p}/politique_confidentialite.pdf`,
        cookies: `${p}/politique_cookies.pdf`,
        cgs: `${p}/cgs.pdf`,
        cgu: `${p}/cgu.pdf`,
    };
}
exports.PUBLIC_LEGAL_FOOTER_DOCUMENT_PDF_PATHS = buildPublicLegalFooterDocumentPdfPaths(exports.DEFAULT_PUBLIC_LEGAL_FOOTER_DOCUMENTS_PREFIX);
exports.PUBLIC_USER_GUIDE_ENTRY_PATH = "/guide/index.html";
